































































































import { Vue, Component, Prop } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import {
  KeysOfType,
  NonFunctionPropertyNames,
  NonFunctionProperties,
} from "../utils/types";
import { stringFormatter } from "../utils/string-formatter";

export enum Priority {
  ASC = "ASC",
  DESC = "DESC",
}

export type CommonFilter<T> = {
  key?: KeysOfType<T, "string"> & string;
};
export type SortBy<T> = CommonFilter<T> & {
  priority: Priority;
};
export type FilterBy<T> = CommonFilter<T> & {
  page: number;
  limit: number;
  value: { [key: string]: any };
};
export type CommonHeader<T> = {
  text: string;
};
export type ListHeader<T> = CommonHeader<T> & {
  key: KeysOfType<T, "string"> & string;
};
export type SortableHeader<T> = ListHeader<T> & {
  sortable: boolean;
};
export type FilterableHeader<T> = ListHeader<T> & {
  allowFiltering: boolean;
};
export type ColumnHeader<T> =
  | CommonHeader<T>
  | SortableHeader<T>
  | FilterableHeader<T>;
export type RowButton<T> = {
  id: string;
  class?: string;
  icon?: {
    class: string | ((arg: T) => string);
  };
  text?: string | ((arg: T) => string);
  label?: string | ((arg: T) => string);
};
export type ListItemIdentifier<T> = NonFunctionPropertyNames<T>;
export type ListBody<T> = {
  values: Array<T>;
  row_headers: Array<ListHeader<T>>;
  rowButtons?: {
    buttons: Array<RowButton<T>>;
    flex?: "column" | "row";
    identifier?: ListItemIdentifier<T>;
  };
};
@Component({
  components: {
    Multiselect,
  },
})
export default class SortTable<T> extends Vue {
  @Prop({ required: true })
  private headers!: Array<ColumnHeader<T>>;

  @Prop({ required: true })
  private currentSort!: SortBy<T>;

  @Prop({})
  private body?: ListBody<T>;

  @Prop({ default: {} })
  private currentFilter: FilterBy<T>;

  private sortBy(header: SortableHeader<T>) {
    if (header.key === this.currentSort.key) {
      this.currentSort.priority =
        this.currentSort.priority === Priority.ASC
          ? Priority.DESC
          : Priority.ASC;
    } else {
      this.currentSort.priority = Priority.ASC;
      this.currentSort.key = header.key;
    }

    this.$emit("sort-list", this.currentSort);
  }

  private filterBy(header: FilterableHeader<T>) {
    this.$emit("filter-list", header);
  }

  private onRowButtonClick(rowButton: RowButton<T>, value: T) {
    this.$emit(`on-${rowButton.id}`, this.body.rowButtons.identifier || value);
  }

  private isFilteringActive(header: FilterableHeader<T>) {
    return this.currentFilter.key == header.key;
  }

  private rowButtonText(rowButton: RowButton<T>, value: T) {
    return (
      (typeof rowButton.text !== "string" && rowButton.text(value)) ||
      rowButton.text
    );
  }

  private rowButtonLabel(rowButton: RowButton<T>, value: T) {
    return (
      (rowButton.label &&
        typeof rowButton.label !== "string" &&
        rowButton.label(value)) ||
      rowButton.label
    );
  }

  private rowButtonIconClass(rowButton: RowButton<T>, value: T) {
    return (
      (typeof rowButton.icon.class !== "string" &&
        rowButton.icon.class(value)) ||
      rowButton.icon.class
    );
  }
}
